import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { Fragment, useContext } from 'react';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { USER } from 'self-service-api/constants/UnitTypes';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import { useAppSelector } from '../../../reducers';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import SeatsPicker from '../../common/quantityPacks/SeatsPicker';
import { Divider } from '../SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuantityPickerUsersLeftAll = ({
  additionalUnitSkuIds,
  trackingSource
}) => {
  const {
    productConfigurations,
    setProductConfigurations,
    showDiscountedPricesInUnitsPicker,
    queryParamTerm
  } = useContext(PlanBuilderContext);
  const getSelectedAdditionalUnitsQuantity = additionalUnitSkuId => {
    const foundConfig = productConfigurations.find(({
      skuId
    }) => skuId === additionalUnitSkuId);
    return foundConfig ? foundConfig.quantity : 0;
  };
  const setAdditionalUnitQuantity = (quantity, additionalUnitSkuId) => {
    setProductConfigurations(() => {
      const filteredConfigs = productConfigurations.filter(({
        skuId
      }) => skuId !== additionalUnitSkuId);
      if (quantity > 0) {
        filteredConfigs.push(createProductConfig({
          skuId: additionalUnitSkuId,
          quantity
        }));
      }
      return filteredConfigs;
    });
  };
  const quantityPackSkuIds = useAppSelector(state => {
    return additionalUnitSkuIds.filter(skuId => skuSelector(state, {
      skuId
    }).quantityUnit);
  });
  const usersAdditionalUnitsSkuIds = useAppSelector(state => {
    return quantityPackSkuIds.filter(skuId => skuSelector(state, {
      skuId
    }).quantityUnit.unitType === USER);
  });

  // Need to group the sales / service seats in a way that looks nice
  const userPickerComponents = usersAdditionalUnitsSkuIds.map((additionalUnitSkuId, index) => /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {
      className: "m-y-7"
    }), /*#__PURE__*/_jsx(SeatsPicker, {
      additionalUnitSkuId: additionalUnitSkuId,
      additionalUnitQuantity: getSelectedAdditionalUnitsQuantity(additionalUnitSkuId),
      onChange: quantity => setAdditionalUnitQuantity(quantity, additionalUnitSkuId),
      productConfigurations: productConfigurations,
      useProductLineSpecificTitle: usersAdditionalUnitsSkuIds.length > 1,
      hideFreeUsersDisclaimer: index < usersAdditionalUnitsSkuIds.length - 1,
      queryParamTerm: showDiscountedPricesInUnitsPicker ? queryParamTerm : MONTHLY,
      trackingSource: trackingSource
    })]
  }, additionalUnitSkuId));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: userPickerComponents
  });
};
export default QuantityPickerUsersLeftAll;